import { useEffect, useState } from "react";
import { PredefinedDataTypes } from "../utils/formTypes";
import usePredefinedDataByType from "../customHooks/usePredefinedType";

import { handleFormEvent } from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
import Input from "../stories/Input/Input";
import { EMPTY_STRING } from "../utils/constants";

interface optionsType2 {
  id: number;
  index: number;
  type: string;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
}

interface Props {
  type: PredefinedDataTypes;
  value: string;
  onChange: (newValue: string, state_code?: string) => void;
  label: string;
  disabled?: boolean;
  name: string;
}
const PredefinedSelect = ({ type, value, onChange, name }: Props) => {
  const [i, setI] = useState(-1);

  const [showOptions, setShowOptions] = useState(false);
  const [predictionResults, setPredictionResults] = useState<optionsType2[]>(
    []
  );

  const {
    PredefinedData: { data },
  } = usePredefinedDataByType(type, value);

  useEffect(() => {
    if (data?.GetPredefinedDataByType.edges) {
      let dataValues = data?.GetPredefinedDataByType.edges;

      setPredictionResults(
        dataValues.map(({ node }) => {
          return {
            id: node.id,
            index: node.index,
            type: node.type,
            value1: node.value1,
            value2: node.value2,
            value3: node.value3,
            value4: node.value4,
          };
        })
      );
    }
  }, [data, name, value]);

  const handleSuggestionClick = (result: optionsType2) => {
    onChange(result.value1, result.value3);
  };

  useEffect(() => {
    const focusInput = document.getElementsByName(name)[0];
    const enableOptions = predictionResults.find(
      (res) =>
        res.value1.toLocaleLowerCase().includes(value?.toLocaleLowerCase()) &&
        value !== EMPTY_STRING
    );

    if (focusInput === document.activeElement && enableOptions) {
      setShowOptions(true);
    } else {
      setShowOptions(false);
    }
  }, [predictionResults, name, value]);

  useEffect(() => {
    document.addEventListener("click", () => {
      setShowOptions(false);
    });

    return () => {
      document.removeEventListener("click", () => {
        setShowOptions(false);
      });
    };
  }, []);
  return (
    <div className="predefined-select">
      <Input
        value={value}
        name={name}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === Keys.ArrowDown) {
            if (predictionResults.length > i + 1) {
              setI(i + 1);
              const selectedItem =
                document.getElementsByClassName("custom-list-item");
              if (selectedItem.length) {
                selectedItem[i + 1].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
            }
          }
          if (e.key === Keys.ArrowUp) {
            if (i !== -1) setI(i - 1);
            const selectedItem =
              document.getElementsByClassName("custom-list-item");
            if (selectedItem[i - 1])
              if (selectedItem.length) {
                selectedItem[i - 1].scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
          }
          if (e.key === Keys.ENTER) {
            e.preventDefault();
            if (predictionResults[i]) {
              onChange(
                predictionResults[i].value1,
                predictionResults[i].value3
              );
              handleFormEvent(e);
            } else {
              handleFormEvent(e);
            }
            setShowOptions(false);
          }
        }}
      />

      {showOptions ? (
        <ul className="list-tag" tabIndex={0}>
          {predictionResults.map((result, index) => {
            return (
              <li
                key={result.id}
                tabIndex={0}
                className={`custom-list-item ${
                  i === index ? "selected-item" : ""
                }`}
                onClick={() => handleSuggestionClick(result)}
              >
                {result.value1}
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
};

export default PredefinedSelect;
